import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { StatusEnum } from '../../../enum/status/status.enum';
import { CashRegisterVendorTypeEnum, CashRegisterVendorTypeEnumValues } from '../../../enum/cash-register/cash-register-vendor-type-enum';
import { AllowedStoreTypeEnum } from '../../../enum/type/allowed-store-type.enum';
import { SelectedItemIdDto } from '../../../models/dto/selectedItemIdDto';
import { CashRegisterEntity } from '../../../models/entity/cash-register/cash-register-entity';
import { CashRegisterVendorSettings } from '../../../models/entity/cash-register/cash-register-vendor-settings.model';
import { AuthService } from '../../../services/auth.service';
import { AlertifyService } from '../../../services/core/alertify.service';
import { CashRegisterService } from '../../../services/cash-register/cash-register.service';
import { StoreCacheService } from '../../../services/cache/store-cache.service';
import { CashRegisterConnectionTypeEnum, CashRegisterConnectionTypeEnumValues } from '../../../enum/cash-register/cash-register-connection-type-enum';
import { DateFormatEnum } from '../../../enum/date-format.enum';

@Component({
  selector: 'app-cash-register-add-update',
  templateUrl: './cash-register-add-update.component.html',
  styleUrls: ['./cash-register-add-update.component.css']
})
export class CashRegisterAddUpdateComponent implements OnInit {


  @Input() data: CashRegisterEntity;
  @Output() passEntry: EventEmitter<any> = new EventEmitter();

  stores: SelectedItemIdDto[] = [];
  isActive: boolean = true;
  cashRegisterVendorTypeEnum = CashRegisterVendorTypeEnum;
  cashRegisterVendorTypeEnumValues = CashRegisterVendorTypeEnumValues;
  cashRegisterConnectionTypeEnum = CashRegisterConnectionTypeEnum;
  cashRegisterConnectionTypeEnumValues = CashRegisterConnectionTypeEnumValues;
  dateFormatEnum = DateFormatEnum;
  vendorSettings: CashRegisterVendorSettings = new CashRegisterVendorSettings();
  vatRateDepartmentMappings: { vatRate: string; departmentCode: number }[] = [];
  constructor(
    private storeCacheService: StoreCacheService,
    private authService: AuthService,
    private cashRegisterService: CashRegisterService,
    private translate: TranslateService,
    private alertifyService: AlertifyService,) { }

  ngOnInit(): void {
    if (this.data) {
      if (this.data.status != StatusEnum.ACTIVE) {
        this.isActive = false;
      }
      this.loadVendorSettings();
    }
    else {
      this.data = new CashRegisterEntity();
      this.data.status = StatusEnum.ACTIVE;
      this.data.storeId = this.authService.getStoreId();
    }
    this.getStores();
  }

  loadVendorSettings() {
    if (this.data.vendorSettings) {
      try {
        this.vendorSettings = JSON.parse(this.data.vendorSettings);
        if (this.vendorSettings.vatRateDepartmentMapping) {
          this.vatRateDepartmentMappings = Object.keys(this.vendorSettings.vatRateDepartmentMapping).map(key => ({
            vatRate: key,
            departmentCode: this.vendorSettings.vatRateDepartmentMapping![key]
          }));
        }
      } catch (e) {
        this.vendorSettings = new CashRegisterVendorSettings();
      }
    } else {
      this.vendorSettings = new CashRegisterVendorSettings();
    }
  }

  onVendorTypeChange() {
    if (!this.isHuginOrBeko()) {
      this.vatRateDepartmentMappings = [];
      this.vendorSettings = new CashRegisterVendorSettings();
    } else {
      this.loadVendorSettings();
    }
  }

  async getStores() {
    try {
      const res = await this.storeCacheService.getStoreSelectList(this.authService.getStoreId(), AllowedStoreTypeEnum.ALLOWED_MANAGE_STORE).toPromise();
      this.stores = res ?? [];

    } catch (err) {
      this.alertifyService.error(err);
    }
  }
  //güncelle veya yeni kayıt ekle
  save() {
    if (!this.validateSave())
      return;


    //Yeni kayıt ise
    if (!this.data.id) {
      this.add();
    }
    //Var olan kaydı güncelle
    else {
      this.update();
    }
  }

  //kontroller
  validateSave() {
    //Status alanı değerini güncelle
    if (this.isActive) this.data.status = StatusEnum.ACTIVE;
    else if (this.data.status == StatusEnum.ACTIVE)
      this.data.status = StatusEnum.PASSIVE;

    // VendorSettings'i JSON string'e çevir
    if (this.data.vendorType === CashRegisterVendorTypeEnum.HUGIN || this.data.vendorType === CashRegisterVendorTypeEnum.BEKO) {
      if (!this.vendorSettings.vatRateDepartmentMapping) {
        this.vendorSettings.vatRateDepartmentMapping = {};
      }
      this.vatRateDepartmentMappings.forEach(mapping => {
        if (mapping.vatRate && mapping.departmentCode != null) {
          this.vendorSettings.vatRateDepartmentMapping![mapping.vatRate] = mapping.departmentCode;
        }
      });
      this.data.vendorSettings = JSON.stringify(this.vendorSettings);
    }

    return true;
  }

  // yeni kayıt ekle
  add() {
    this.cashRegisterService.addCashRegister(this.data).subscribe(
      (res) => {
        this.data = res;
        this.alertifyService.success(this.translate.instant('message.info.saved'));
        this.passEntry.emit(this.data);

      },
      (err) => {
        this.alertifyService.error(err);
      }
    );
  }

  // güncelle
  update() {
    this.cashRegisterService
      .updateCashRegister(this.data.id, this.data)
      .subscribe(
        (res) => {
          this.data = res;
          this.alertifyService.success(this.translate.instant('message.info.updated'));
          this.passEntry.emit(this.data);
        },
        (err) => {
          this.alertifyService.error(err);
        }
      );
  }

  close() {
    this.passEntry.emit();
  }

  addVatRateDepartmentMapping() {
    this.vatRateDepartmentMappings.push({ vatRate: '', departmentCode: 0 });
  }

  removeVatRateDepartmentMapping(index: number) {
    this.vatRateDepartmentMappings.splice(index, 1);
  }

  isHuginOrBeko(): boolean {
    return this.data?.vendorType === CashRegisterVendorTypeEnum.HUGIN || this.data?.vendorType === CashRegisterVendorTypeEnum.BEKO;
  }

  isHuginBekoOrPavo(): boolean {
    return this.data?.vendorType === CashRegisterVendorTypeEnum.HUGIN ||
      this.data?.vendorType === CashRegisterVendorTypeEnum.BEKO ||
      this.data?.vendorType === CashRegisterVendorTypeEnum.PAVO;
  }
}
